import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { accessFeature } from './store/access.reducer';
import { AccessEffects } from './store/access.effects';
import { AccessUiModule } from './access-ui.module';

/**
 * Ядро ролевой модели (F1+F2): регистрирует feature-стор `access` и эффекты.
 * Импортируется ОДИН раз — в AppModule. Директива `*hasPerm` живёт в AccessUiModule
 * (его импортируют feature-модули, чтобы не дублировать регистрацию стора/эффектов).
 */
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(accessFeature),
    EffectsModule.forFeature([AccessEffects]),
    AccessUiModule,
  ],
  exports: [AccessUiModule],
})
export class AccessModule {}
